import { Injectable } from "@angular/core";
import { CanActivate, Router, UrlTree } from "@angular/router";

import { AuthService } from "../services/auth.service";
import { Logger } from "src/app/core/logger/logger.service";
import { AuthFacade } from '../store/facade/auth.facade';

@Injectable()
export class AuthGuard implements CanActivate {
  log = new Logger("AuthGuard");

  constructor(private router: Router, private authFacade: AuthFacade) { }

  canActivate(): boolean | UrlTree {
    const token = localStorage.getItem("jwt");
    const now = Math.floor(new Date().getTime() / 1000);
    this.log.debug(token);
    if (token) {
      const expire = AuthService.jwtDecode(token);
      if (expire.exp > now) {
        //restore store with tokens
        this.authFacade.restoreSession();
        this.log.debug("Valid token");
        return true;
      } else {
        this.log.debug("Expired token ", token);
        localStorage.removeItem("token");
        localStorage.removeItem("jwt");
        return this.router.createUrlTree(["/login"]);
      }
    }
    return this.router.createUrlTree(["/login"]);
  }
}
